var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonIconButtonEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.01,
    d: "M.519 0H42v40H.519z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.926 25.25V29h3.889l11.47-11.06-3.89-3.75-11.469 11.06zm18.366-10.21a.97.97 0 0 0 0-1.41l-2.427-2.34a1.06 1.06 0 0 0-1.462 0l-1.898 1.83 3.89 3.75 1.897-1.83z",
    fill: "#00A8C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconButtonEdit);
export default __webpack_public_path__ + "static/media/Button_iconButton_edit.1d9e1cf2425ac3abfe9256706463aa0e.svg";
export { ForwardRef as ReactComponent };